import React from 'react';

export default {
    SimpChn : {
        formTitle: "「综合注册资讯系统」网上服务 - 登记用户账户申请表", 
        
        steps_Particulars: "申请资料",

        termsAndConditionsOf: "「综合注册资讯系统」网上服务的使用条款及条件",
        readAndUnderstandTerms: "本人/我们已细阅及明白上述的「一般使用条款」及「「综合注册资讯系统」网上服务的使用条款及条件」，并同意受其约束。",
        termsAndConditions_body: ()=> [
            <div style={{lineHeight:"1.5", marginLeft:"1rem", marginBottom:"0.5rem"}}>
                <h4>「综合注册资讯系统」网上服务提供的服务</h4>
                <div class="clauses">
                    <div>1.&emsp;登记用户的申请经土地注册处审批后，即构成一份土地注册处与登记用户之间的协议( “本协议”)。土地注册处会按本协议所载的条款及条件向登记用户提供以下第3条所界定的一些网上服务( “「综合注册资讯系统」网上服务”)。本协议包含以下各文件–即「登记用户申请表」、本「条款及条件」及「收集个人资料声明」。</div>
                    <div>2.&emsp;本条款及条件每项条文的标题只供参考，不会影响该条文的解释。</div>
                    <div>3.&emsp;登记用户可透过互联网使用土地注册处「综合注册资讯系统」( “综合系统”)所提供的网上服务。登记用户必须遵守本条款及条件的所有条文，以及遵从屏幕格式上所展示的任何其他指示。在缴付本协议中所述的各项相关收费后，便可使用以下的「综合注册资讯系统」网上服务，包括-</div>
                    <ol><div>3.1&emsp;在浏览器上阅览所选取土地注册处备存及保存的土地登记册、经影像处理的文书及图则和尚未记入土地登记册的注册摘要资料（“土地纪录” ）；</div></ol>
                    <ol><div>3.2&emsp;从网上下载或订购及以不同方法 (包括传真、邮递、电邮或在柜位领取)收取选购的土地纪录的副本；及</div></ol>
                    <ol><div>3.3&emsp;取得土地注册处不时公布的其他类别服务。</div></ol>
                    <div>4.&emsp;登记用户如须透过互联网接达「综合注册资讯系统」网上服务，必须自行就连接「综合注册资讯系统」网上服务网站和日后切断接驳的事宜与有关互联网、流动通讯或电讯服务供应商作出安排，并须自行承担有关费用。登记用户亦须自行安排使用「综合注册资讯系统」网上服务所需的电脑硬件、软件、通讯链路、设备及装置，并须自行承担有关开支。</div>
                    <div>5.&emsp;土地注册处有绝对酌情权，可就「综合注册资讯系统」网上服务提供的不同类别的产品及服务作出限制，只提供予某些类别的使用者使用。「综合注册资讯系统」网上服务的每日运作及服务时间以土地注册处不时在两个网页(即http://www.landreg.gov.hk及http://www.iris.gov.hk)所公布的为准，土地注册处有权随时更改上述时间而毋须事先发出通知。本处可不时就不同类别的服务规定不同的截止服务时间，有关时间可以是早于服务网站(即http://www.iris.gov.hk )每日的停止运作时间。</div>
                </div>
                <h4>登记用户帐户、按金、费用、登入识别码、密码等</h4>
                <div class="clauses">
                    <div>6.&emsp;在使用「综合注册资讯系统」网上服务前，登记用户必须先行-
                        <ol><div>6.1&emsp;向土地注册处交付-</div></ol>
                        <div>
                            <ol><div>6.1.1&emsp;申请手续费港币1,500.00元(此费一经收讫，概不退还)，以便土地注册处为登记用户开设和保存一个帐户(“登记用户帐户”)，并根据本协议为登记用户编配一个用以识别该登记用户帐户的登入识别码(“登入识别码”)。</div></ol>
                            <ol><div>6.1.2&emsp;(如适用的话)如登记用户有需要申请额外的登入识别码，对每个附加登入识别码须另付行政费用港币750.00元(此费一经收讫，概不退还)。</div></ol>
                            <ol><div>6.1.3&emsp;不作生息的按金(“按金”)，金额港币500.00元或由土地注册处不时另定的其他最低按金金额。</div></ol>
                        </div>
                        <ol><div>6.2&emsp;在土地注册处认可的银行开设银行户口(“该银行户口”)，并签署和填妥一份直接付款授权书，然后交回土地注册处，以便本处以自动转帐形式收取登记用户就使用「综合注册资讯系统」网上服务的任何帐户所应缴的费用。</div></ol>
                    </div>
                    <div>7.&emsp;如同一人或同一公司欲以不同帐户姓名或名称开设额外登记用户帐户，可另行填写申请表提出申请，并按第6.1条做法缴付申请费、行政费及按金。</div>
                    <div>8.&emsp;「综合注册资讯系统」网上服务内不同类别服务的收费，以土地注册处不时在两个网页(即http://www.landreg.gov.hk及http://www.iris.gov.hk) 上公布的为准。土地注册处有权随时更改各项收费而毋须事先发出通知。</div>
                    <div>9.&emsp;登记用户帐户下的使用者或被视作获登记用户授权的使用者(见下文第13至15条)一旦透过综合系统确认所订购的服务，有关费用便会记入登记用户的帐户。除非另有述明或显示，否则「综合注册资讯系统」网上服务的任何产品或服务的所有收费均以港币计算。所有与「综合注册资讯系统」网上服务有关的交易均以港币进行。</div>
                    <div>10.&emsp;土地注册处每月都会就每个登记用户帐户向用户发出网上月结单，详列该登记用户帐户的每个登入识别码在先前一个月内所使用的服务类别和服务费用。除涉及欺诈的情况外，月结单如有任何错漏，双方必须在月结单送达登记用户起计14天内向对方提出，否则之后月结单内容将作属实，各方均不得提出异议。</div>
                    <div>11.&emsp;如登记用户未能透过其自动转帐银行户口全部清偿其应支付的费用，土地注册处可随时利用按金清偿欠款而毋须事先通知登记用户。</div>
                    <div>12.&emsp;除非本协议另有规定，否则按金不可转移或转让。土地注册处可不时要求登记用户缴付与其过往处理交易的数量和价值相称的额外按金。未用的按金余额会在本协议终止时，并在土地注册处扣除所有合理申索后，退还登记用户但不附任何利息。</div>
                </div>
                <h4>登入方式</h4>
                <div class="clauses">
                    <div>13.&emsp;一般方式登入：如登记用户已在申请表中选择一般方式登入(即没有使用数码证书)，他的每个登入识别码均会获编配一个独有的密码。使用者必须同时键入登记用户帐户的独有登入识别码和密码，方可获准使用「综合注册资讯系统」网上服务。任何同时键入登记用户帐户独有登入识别码和密码的使用者将被视作获登记用户授权的使用者而有权使用「综合注册资讯系统」网上服务，有关收费会记入登记用户的帐户。就本协议的所有目的而言，登记用户须对自己及上述使用者的一切作为或不作为负上法律责任。</div>
                    <div>14.&emsp;以数码证书方式登入：如登记用户已在申请表中为每个登入识别码选择以数码证书的方式登入，使用者的身分会藉由香港认可核证机关(现时为邮政署署长(香港邮政核证机关)及电子核证服务有限公司)根据《电子交易条例》(第553章)发出并已在土地注册处登记存案的数码证书核实。使用者必须同时键入登记用户帐户的独有登入识别码和相关数码证书的密码，方可获准使用「综合注册资讯系统」网上服务。任何同时键入登记用户帐户独有登入识别码和相关数码证书的密码的使用者将被视作获登记用户授权的使用者而有权使用「综合注册资讯系统」网上服务，有关收费会记入登记用户的帐户。就本协议的所有目的而言，登记用户须对自己及上述使用者的一切作为或不作为负上法律责任。</div>
                    <div>15.&emsp;以「智方便」方式登入：登记用户除选择以密码或数码证书登入之外，登记用户可选择把使用者的「智方便」户口连结至「综合注册资讯系统」网上服务的登入识别码，从而由香港特别行政区政府推出的「智方便」流动应用程式认证使用者的身分。使用者的「智方便」户口必须连结至登入识别码，而使用者的身分亦必须已由「智方便」认证，方可获准使用「综合注册资讯系统」网上服务。登记用户帐户的主管登入识别码可以经由「综合注册资讯系统」允许或不允许登记用户帐户的其他登入识别码连结使用者的「智方便」户口。任何已将「智方便」户口连结至其登入识别码及已由「智方便」认证身分的使用者将被视作获登记用户授权的使用者而有权使用「综合注册资讯系统」网上服务，有关收费会记入登记用户的帐户。就本协议的所有目的而言，登记用户须对自己及上述使用者的一切作为或不作为负上法律责任。</div>
                    <div>16.&emsp;登记用户须采取适当保护措施把土地注册处配予的登入识别码和密码保密。登记用户切勿容许任何人士与其共用同一个登入识别码。如综合系统侦测到有人同时在以同一个登入识别码使用「综合注册资讯系统」网上服务，所有同时在线正于屏幕上进行的使用或操作将被即时停止或取消或以其他方式阻断而无须预先发出任何警告，而土地注册处亦无须就任何该等使用或操作的中断负责。</div>
                    <div>17.&emsp;土地注册处备存的土地纪录载有个人资料。每当登记用户透过其使用者或被视作获登记用户授权的使用者登入登记用户帐户使用「综合注册资讯系统」网上服务及取得包含个人资料的土地纪录(不论是以浏览器阅览或以下载或其他方法收取)，登记用户须按照「综合注册资讯系统」网上服务的「收集个人资料声明及客户确认声明」页面显示的条款，作出及提交有关限制使用土地纪录内的个人资料的确认声明。如登记用户选用第13条所述以一般方式登入或第14条所述以数码证书方式登入，使用者须填写其姓名及香港身份证号码或护照号码(连同签发国家或机关)。如登记用户选用第15条所述以「智方便」方式登入，使用者须填写其姓名或授权其「智方便」户口提供其姓名予「综合注册资讯系统」网上服务。使用者作为登记用户或代表登记用户(若使用者不是登记用户)，须在「收集个人资料声明及客户确认声明」页面所显示的确认声明之下，按下「确认及接受」按钮以作出及提交确认声明。使用者有责任提供「综合注册资讯系统」网上服务所需的个人资料。如未能提供有关资料，土地注册处可拒绝其订购「综合注册资讯系统」网上服务提供的产品或服务的要求。</div>
                </div>
                <h4>因按金不足而中止提供服务</h4>
                <div class="clauses">
                    <div>18.&emsp;如登记用户仍未缴清订单或所需服务的费用，土地注册处可随时中止向登记用户提供服务而毋须事先发出通知，直至登记用户悉数清付尚欠的费用及补充当时要求的最低按金金额为止。</div>
                </div>
                <h4>不退款政策</h4>
                <div class="clauses">
                    <div>19.&emsp;就土地注册处采用的一般政策而言，登记用户如对于已付讫的或入帐的「综合注册资讯系统」网上服务提供的产品或服务感到不满，土地注册处只会接受用户退货更换或为用户重新提供服务作为补救办法，但不会作任何退款。</div>
                </div>
                <h4>限制订单的总值或数量</h4>
                <div class="clauses">
                    <div>20.&emsp;土地注册处可不时限制登记用户在某特定时间或某时段的订单总值或总量，而毋须事先发出通知。有关限制可能内置于综合系统而不会在任何屏幕格式显示。登记用户的所有订单均须受该限制约束。</div>
                </div>
                <h4>中止或拒绝订单</h4>
                <div class="clauses">
                    <div>21.&emsp;土地注册处可在下述情况拒绝或取消订购要求，或中止提供「综合注册资讯系统」网上服务，包括但不限于中止或处理任何订单而毋须事先发出通知。该等情况是指每当综合系统侦测到任何实质或怀疑自动检索或下载资料或任何迹象、信息或信号，显示综合系统的硬件或软件或与其连接的系统、网络、设备或装置可能会遭到不利影响、干扰或损毁的各种风险，不论有关风险属实体性或功能性，直接或间接，或暂时或永久。</div>
                </div>
                <h4>不保证从外界资讯来源取得用以查找地段登记册的资料的准确性</h4>
                <div class="clauses">
                    <div>22.&emsp;在查阅地段的土地登记册(即「地段登记册」)，而这登记册只能以地段编号查找而无法只凭街道地址在综合系统中找到时，土地注册处可能会利用来自外界(例如差饷物业估价署)的资料来查找与你所提供地址相符的有关地段登记册。此举纯粹是一项为了方便客户查册而额外提供的免费服务。由于从其他来源取得的资料不能确定为免于错误或遗漏，因此以此方法找出的地段登记册可能有别于你想要查找的登记册。土地注册处对于从外界资讯来源取得的资料及其使用，与及有关的配对程序、绝不保证它们没有任何错误或遗漏 (不论明示的或隐含的保证都没有)。在你按照从配对程序获得的查找结果行事之前，你必须小心将其与你手上其他方面的资料相互对照，以确保所获得的地段登记册确实是你要查找的物业。对于任何因从外界来源取得的资料或其使用，以及有关配对程序中出现的任何错误或遗漏而引致的任何性质的损失或损害(不论如何引致)，土地注册处概不承担任何法律责任或责任。土地注册处有绝对酌情权，随时删除或修订所有或任何部分从外界来源取得的现存资料，又或暂停提供配对程序的服务，而毋须向你给予任何理由或预先通知。</div>
                </div>
                <h4>限制使用所提供的产品和服务</h4>
                <div class="clauses">
                    <div>23.&emsp;除另有说明外，「综合注册资讯系统」网上服务所提供的任何产品或服务的软件、资料或文件或其中任何部分，均须受香港特别行政区政府所拥有的版权及其他知识产权规限。除非事先获得土地注册处的书面同意，登记用户不得将任何从「综合注册资讯系统」网上服务获取的产品或服务(包括当中任何资料)或其中任何部分，以任何形式或方法出售，或藉出借、出租或给予特许使用权以换取任何得益、利润或报酬，或以任何形式复印、复制或编辑任何该等产品或服务或其中任何部分(包括当中任何资料)，从而另制产品作出售、出借、出租或给予特许使用权之用。</div>
                    <div>24.&emsp;登记用户不得把「综合注册资讯系统」网上服务，或据此取得的任何产品或服务或其中任何部分，用于任何违法或非法的活动上，特别是不得用于违反《个人资料（私隐）条例》(第486章)或《版权条例》(第528章) 任何条文的任何活动或目的。任何企图操控从「综合注册资讯系统」网上服务获取的产品或服务的资料或其中任何部分(例如在「综合注册资讯系统」网上服务就土地纪录提供的搜寻键外另行设立新的搜寻键)，一律禁止。违反本条款会导致协议被终止。</div>
                    <div>25.&emsp;如登记用户透过其使用者或被视作获登记用户授权的使用者(见上文第13至15条)在香港以外的地方使用「综合注册资讯系统」网上服务，登记用户须负责确保自「综合注册资讯系统」网上服务订购的产品或服务可合法传送或送递至登记用户所指明的目的地，并且已为登记用户、产品送递者或服务提供者办妥全部所需的出入口申报或税务手续。登记用户须就任何违反这项条件的行为所导致的所有不良后果及所有损失或损害，向土地注册处作出十足弥偿，确保土地注册处不会因此而蒙受损害。</div>
                </div>
                <h4>豁免条款</h4>
                <div class="clauses">
                    <div>26.&emsp;在法律许可的范围内，土地注册处不须就使用「综合注册资讯系统」网上服务，或与此有关的事宜所引致的任何损失或损害赔偿(包括任何性质的损失或损害赔偿及不论如何引致的损失或损害赔偿)，向登记用户或任何第三者负责。在不限制前文的一般性的原则下，土地注册处不会对于因下述情况，或与该等情况有关而引致的任何损失或损害赔偿负责：-
                        <ol><div>26.1&emsp;综合系统及与其连接的系统、网络、设备或装置的任何故障、中止运作、失灵、机能失常或任何其他失误或操作中断；</div></ol>
                        <ol><div>26.2&emsp;透过综合系统及与其连接的系统、网络、设备或装置而处理或传送数据或与此有关而引致数据上的任何错误、遗漏、误差或不足之处；</div></ol>
                        <ol><div>26.3&emsp;中止或延误处理「综合注册资讯系统」网上服务的任何订单，或中止或延误提供「综合注册资讯系统」网上服务的任何服务；及</div></ol>
                        <ol><div>26.4&emsp;因登记用户使用「综合注册资讯系统」网上服务而导致登记用户的网络、电脑、调解器、电话系统、设备、流动电话或其他装置的硬件或软件遭受任何损害。</div></ol>
                    </div>
                    <div>27.&emsp;综合系统属电子资讯系统并且连接至多个由第三方提供的不同网络。土地注册处无责任协助任何登记用户追查或寻找与综合系统及与其连接的系统、网络、设备及装置的硬件或软件的设计或操作有关的任何投诉或不满的问题。登记用户也无权就该等原因或其他目的(包括与诉讼有关的任何目的)要求查核或检查上述任何器件。</div>
                    <div>28.&emsp;土地注册处并不保证登记用户所订购的任何产品或服务会及时或准时送至登记用户以符合其所须达到的任何特定目的。</div>
                </div>
                <h4>终止协议</h4>
                <div class="clauses">
                    <div>29.&emsp;土地注册处可按下述任何一个方式终止本协议及「综合注册资讯系统」网上服务：-
                        <ol><div>29.1&emsp;发出通知：不需提出任何理由，惟事先在不少于30天前向登记用户发出书面通知。</div></ol>
                        <ol><div>29.2&emsp;不活跃帐户：如登记用户帐户已连续超过12个月没有使用有关服务，事先在不少于14天前以书面发出通知。</div></ol>
                        <ol><div>29.3&emsp;违反协议：如登记用户违反本协议所载的任何条款或条件，土地注册处可即时发出书面通知，述明违约的性质(“违反协议通知”)。遇有因违反协议通知而引起终止协议的任何纠纷，土地注册处可以凭借登记用户事实上所犯的其他违约事项作为额外或替代的行事理由，而且不论该违约事项是发生于违反协议通知书之前或之后，又或即使上述违反协议通知内容未有提及该违约事项，土地注册处仍然可以如此行事。</div></ol>
                    </div>
                    <div>30.&emsp;登记用户可随时终止本协议，惟须事先在不少于30天前以书面通知土地注册处。</div>
                    <div>31.&emsp;根据第29或30条终止本协议，无损任何一方针对对方因其违反本协议，或因其先前已违反本协议，而产生或可能已产生的任何权利或申索。本协议被终止时，所有已缴付的费用都不获退还，但未用的按金会根据第12条退还。</div>
                </div>
                <h4>更改条款及条件通知</h4>
                <div class="clauses">
                    <div>32.&emsp;如土地注册处拟对本协议的条款及条件作出任何更改，会事先在不少于7天前通知登记用户。如登记用户在该通知期限届满后继续使用「综合注册资讯系统」网上服务并订购任何产品或服务，将被当作接受该等更改并受有关更改约束。</div>
                </div>
                <h4>不得转让权利和利益</h4>
                <div class="clauses">
                    <div>33.&emsp;本协议所载的登记用户权利及利益属登记用户个人所有，不得加以转让或转移。本条款不会宽免任何登记用户帐户使用者因与使用「综合注册资讯系统」网上服务有关或相关的任何侵权行为或其他非法或不法活动而须负上的个人法律责任。</div>
                </div>
                <h4>送达通知和更改资料</h4>
                <div class="clauses">
                    <div>34.&emsp;除非本协议订明特定的送达方式，否则土地注册处根据本协议须给予登记用户的任何通知或文件，都可以一般平邮邮递方式送往登记用户在土地注册处记录中的最后为人所知的地址，或可以传真方式或电子邮件方式发送至登记用户在土地注册处记录中最后为人所知的传真号码或电邮地址。</div>
                    <div>35.&emsp;登记用户在订购申请表第一部提供的资料如有任何更改，须即时以书面通知土地注册处。</div>
                </div>
                <h4>适用的法律及法庭司法管辖权</h4>
                <div class="clauses">
                    <div>36.&emsp;本协议(包括当中的任何更改)须受香港特别行政区的法例规管和根据香港特别行政区的法例解释。各方之间因本协议引起的争议，须诉诸香港特别行政区具司法管辖权的法庭或审裁处裁决。</div>
                </div>
            </div>
        ],
         
        PICSContentCustom: ()=>      [<> 
            <p><span style={{textDecoration:"underline"}}>收集目的</span></p>
            <p>1.&emsp;土地注册处将会把本表格所收集的个人资料用于以下目的:-
                <ul style={{listStyle: "none"}}>
                    <li style={{marginTop:"0.5rem"}}>1.1&emsp;处理与土地注册处提供服务有关的事宜及执行有关职能；</li>
                    <li style={{marginTop:"0.5rem"}}>1.2&emsp;方便进行联络；以及</li>
                    <li style={{marginTop:"0.5rem"}}>1.3&emsp;制备与土地注册处服务有关的统计资料。</li>
                </ul>
            </p>
            <p>你明白提供个人资料是必须的。倘若你不提供本表格所要求的资料，本处可能无法提供所要求的服务。</p>
            <p>请勿提供任何没有明确规定必须提交的个人资料（包括关乎第三者的个人资料）。如本表格或与其有关而存档的文件中包含任何第三者的资料，本处将视作你已获该第三者同意披露该等资料，以用于上述目的。</p>
            
            <p><span style={{textDecoration:"underline"}}>个人资料的披露</span></p>
            <p>2.&emsp;你明白为达到上文第一段中所述明目的而及有需要时，你在本表格内所提供的个人资料可能会披露或转交予相关人士，该等个人资料亦可能会在《个人资料（私隐）条例》（第486章）许可下披露或转交予执法机关。</p>    
            <p><span style={{textDecoration:"underline"}}>查阅个人资料</span></p>
            <p>3.&emsp;你明白根据《个人资料(私隐)条例》(第486章) 第18和第22条，以及附表1第6原则，你有权要求查阅及改正本处所持有你的个人资料。根据该条例，本处有权就处理该等要求收取费用。任何该等要求可向本处的个人资料(私隐)主任提出(地址：香港金钟道66号金钟道政府合署28楼土地注册处)。</p>
        </>]
        ,

        // Form fields
        part_1_Particulars: "I 申请者详细资料", 
        part_2_MDB: "II 申请及付款方法", 
        part_3_SignInfo: "III 签署者资料",         
        part_4_AutopayFacility: "利用自动转账系统缴交「综合注册资讯系统」网上服务费", 
        
        // Form - Part1
        SubscriberName: "登记用户名称", 
        SubscriberNameSubLabel: "提交网上申请的个人登记用户申请人需提供英文名称。",
        BusinessAddress: "办公地址", 
        Email: "电邮地址", 
        OLS1_TelNo: "电话号码", 
        OLS1_FaxNo: "传真号码", 
        // CSP_MemNo: "传递公司 /会员编号", // Removed by SCR-14542
        BusinessType: "业务性质", 
        field_businessType_list:[
            {id: "BusinessType", value: "1. Accountant Firm /會計師行", text: "会计师行"},
            {id: "BusinessType", value: "2. Bank / 銀行", text: "银行"},
            {id: "BusinessType", value: "3. Finance / Investment Co./ 財務/投資公司", text: "财务/投资公司"},
            {id: "BusinessType", value: "4. Newspaper & Publisher / 報章及出版商", text: "传媒机构及出版商"},
            {id: "BusinessType", value: "5. Real Estate Developer / 地產發展商", text: "地产发展商"},
            {id: "BusinessType", value: "6. Real Estate Broker & Agent / 地產經紀及代理", text: "地产经纪及代理"},
            {id: "BusinessType", value: "7. Search Co. / 查冊公司", text: "查册公司"},
            {id: "BusinessType", value: "8. Solicitors Firm / 律師行", text: "律师行"},
            {id: "BusinessType", value: "9. Surveyors Firm/Valuation Consultant / 測量師行/物業估價顧問", text: "测量师行/物业估价顾问"},
            {id: "BusinessType", value: "10. Public Utility / 公用事業", text: "公用事业"},
            {id: "BusinessType", value: "11. Quasi Government Organisation / 半官方組織", text: "半官方组织"},
            {id: "BusinessType", value: "12. Others / 其他", text: "其他"},
        ],
        BR_CR_PI_PN_Type: "身分证明类别", 
        field_BR_CR_PI_PN_Type_list:[
            {id: "BR_CR_PI_PN_Type", value: "BR_CR_PI_PN_Type_Opt1", text: "商业登记"},
            {id: "BR_CR_PI_PN_Type", value: "BR_CR_PI_PN_Type_Opt2", text: "公司注册"},
            {id: "BR_CR_PI_PN_Type", value: "BR_CR_PI_PN_Type_Opt3", text: "护照"},
            {id: "BR_CR_PI_PN_Type", value: "BR_CR_PI_PN_Type_Opt4", text: "香港身分证"},
            {id: "BR_CR_PI_PN_Type", value: "BR_CR_PI_PN_Type_Opt5", text: "其他身分证明文件 (请注明)"},
        ],
        pleaseSpecify: "请注明",
        BR_CR_PI_PN: "身分证明号码", 
        Respect: "联络人称谓", 
        offlinePaymentList:[ 
            {value:"cheque", text:"支票", extraField:"支票编号", extraFieldId: "CDChequeOrBankDraftNo", extraFieldProps: { numericHyphen: true }},
            {value:"bank draft", text:"银行本票", extraField:"编号", extraFieldId: "CDChequeOrBankDraftNo", extraFieldProps: { numericHyphen: true }},
        ],
        
        field_Respect_list: [
            {id:"Respect", value: "NaN_Choice2_Opt_1", text: "先生"},
            {id:"Respect", value: "NaN_Choice2_Opt_2", text: "小姐"},
            {id:"Respect", value: "NaN_Choice2_Opt_3", text: "太太"},
            {id:"Respect", value: "NaN_Choice2_Opt_4", text: "女士"},
        ],
        OLS1_ContactPerson: "联络人姓名", 
        OLS1_BankName: "自动转账银行名称", 
        AccountNo: "自动转账帐户号码", 
        AccountHolder: "自动转账帐户持有人姓名/名称", 
        LoginMethod: "登入方法", 
        field_loginMethod_list:[
            {id: "LoginMethod", value: "Normal Login (without Digital Certificate) / 一般方式登入（沒有數碼證書）", text: "一般方式登入（没有数码证书）"},
            {id: "LoginMethod", value: "Login with Digital Certificate (Hongkong Post CA e-Cert Subscriber Reference No. / 以數碼證書方式登入（香港郵政核證當局e-Cert電子證書登記用戶檔號）", text: "以数码证书方式登入（香港邮政核证当局e-Cert电子证书）" },
            {id: "LoginMethod", value: "Login with Digital Certificate (Digi-Sign CA ID-Cert Subscriber Reference No. / 以數碼證書方式登入（電子核證服務有限公司核證當局ID-Cert登記用戶檔號）", text: "以数码证书方式登入（电子核证服务有限公司当局核证ID-Cert）" },
        ],
        HongKongPostRefNo: "登记用户档号", 
        DigiSignRefNo: "登记用户档号", 
        
        // Form - Part2
        FeeType: "费用和按金", 
        feeType_notes: ()=>[
            <>
                {/* <h4 style={{fontSize:"0.875rem", fontWeight:"bold"}}>Notes :</h4> */}
                <p>有关计算按金金额的详请，请参阅「申请须知」简介(LR/OLS/3)注2</p>
            </>
        ],
        field_feeType_list:[
            {id: "FeeForApplication", value: "Yes", name: "申请费 (港币1,500元)" },
            {id: "FeeForSupplementaryLoginID", value: "Yes", name: "额外登入识别码费用 (每个编号计港币750元)" },            
        ],
        FeeForApplication:"申请费 (港币1,500元)",
        DepositAmount:"按金 (港币)", 
        
        FeeForSupplementaryLoginID:"额外登入识别码费用 (每个编号计港币750元)",
        SupplementaryLoginNo:"登入识别码数量",

        // Form - Part3
        SubscriberType: "登記用戶类别",         
        field_subscriberType_list:[
            {id: "SubscriberType", value: "0", text: "個人登記用戶"},
            {id: "SubscriberType", value: "1", text: "机构登記用戶"},
        ],
        OLS1_NameEN: "签署者名称", 
        SignatoryTitle: "签署者职衔", 
        IdDocAttach: "上载身分证明文件", 
        IdDocAttach_notes: ()=>[
            <>
                <p>机构申请者需提供显示机构名称的证明文件。</p>
            </>
        ],

        // Form - Part4
        autopay_notes: () => [
            <>
                <p>完成此部分后, 请按「列印已填妥的自动转账表格」列印表格。请于列印本上签名，然后将表格正本递交予本处。</p>
            </>
        ],
        AuthorisationDate: "授权书日期", 
        BankName: "本人/吾等之银行及分行之名称", 
        BankNo: "银行编号", 
        BranchNo: "分行编号", 
        AccNo: "本人/吾等之账户号码", 
        Name: "本人/吾等在结单/存摺上所记錄之名", 
        ContactTelNo: "聯络电话号码", 
        Address: "本人/吾等在结单/存摺上所记錄之地址", 
        NameOfDebtor: "债务人之姓名（若非账户持有人）", 
        PrintAutoPayForm: "列印已填妥的自动转账表格",
        ModeOfPayment: "付款方式",
        FeesAndDeposits: "付款金额",
        SignMain: "登记用户签署",
        SignOrg: "登记用户授权签署",

        notes_pleaseSubmitAutopayForm_1: "请下载利用",
        notes_pleaseSubmitAutopayForm_2: "自动转账系统缴交「综合注册资讯系统」网上服务费表格",
        notes_pleaseSubmitAutopayForm_3: "。列印并填妥后请将正本递交至土地注册处，以完成是次申请。",
        
        acknowledgementWarning: ()=>(
            <p>请下载及填妥<a className="url-link"  target="_blank" href="https://www.landreg.gov.hk/pdf/lr-ols-2.pdf">利用自动转账系统缴交「综合注册资讯系统」网上服务费之表格</a>并请在<b>5个工作日</b>内将<b>正本</b>邮寄或亲身递交<a className="url-link"  target="_blank" style={{textDecoration:"underline"}} href="https://www.landreg.gov.hk/chs/contact/contact_2.htm">土地注册处</a>，以完成是次申请。</p>
        ),

        owner_notes: formData => (
            <div>
                <ol>
                    <li>本人已细阅附随申请表关于「综合注册资讯系统」网上服务的「条款及条件」和「收集个人资料声明」，并同意受该等条款及条件和声明约束。</li>
                    <li>本人明白土地注册处根据《土地注册条例》(第128章)备存的土地纪录(「土地纪录」)载有个人资料，而备存和供公众人士查阅土地纪录是为了防止秘密及有欺诈成分的物业转易，以及提供容易追溯和确定土地财产及不动产业权的方法。本人确认本人无意及不会在违反《个人资料(私隐)条例》第486章的情况下使用经「综合注册信息系统」网上服务取的土地纪录所载的个人资料；或将该等个人资料用于与备存及供公众人士查阅土地纪录的宗旨无关之目的。</li>
                    <li>本人确认第一部份所提供的资料正确。</li>
                    <li>本人明白，如申请不获接纳，所有就这份申请而缴付的费用和按金将会退还本人但不附任何利息。</li>
                </ol>
            </div>
        ),
    }
}